export default from './ThemeProvider';
export { default as theme } from './theme';



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/index.js